import React from 'react';
import {Filter} from '../../../../common/components/tableFilters';
import {Table} from 'semantic-ui-react';
import {nullFilter} from '../../../../common/components/commercialTable/utils';
import {useTable, useFilters, useRowSelect} from 'react-table';
import {DefaultOrderColumnFilter} from '../../../../manageOrders/components/internalCommons/TableFilters';

const MaintainanceTable = ({columns, data, loading, updateMyData = () => null}) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    rows,
  } = useTable(
    {
      columns,
      data,
      updateMyData,
      'defaultColumn': {'Filter': DefaultOrderColumnFilter, 'filter': nullFilter},
      'autoResetFilters': false,
      'filter': nullFilter,
    },
    useFilters,
    useRowSelect,
  );

  return (
    <>
      <div
        className={'prices-wrapper-table'}
      >
        <Table className="interactive" striped {...getTableProps()}>
          <Table.Header>
            {headerGroups.map((headerGroup) => (
              <Table.Row key="headers" {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, index) => (
                  <Table.HeaderCell
                    key={`title-${index}`}
                    textAlign="center"
                    {...column.getHeaderProps()}
                  >
                    {column.render('Header')}
                  </Table.HeaderCell>
                ))}
              </Table.Row>
            ))}
            {headerGroups.map((headerGroup) => (
              <Table.Row key="filters" id="filters">
                {headerGroup.headers.map((column, index) => (
                  <Table.HeaderCell
                    key={`filter-${index}`}
                    className={index === 7 ? 'dropdown-header' : ''}
                    textAlign="center"
                  >
                    <Filter column={column} />
                  </Table.HeaderCell>
                ))}
              </Table.Row>
            ))}
          </Table.Header>
          <Table.Body {...getTableBodyProps()}>
            {loading ? (
              <Table.Row>
                <Table.Cell colSpan={15} textAlign="center">
                  Espere...
                </Table.Cell>
              </Table.Row>
            ) :
              <>
                {!rows?.length ? (
                  <Table.Row>
                    <Table.Cell colSpan={15} textAlign="center">
                      No hay datos disponibles
                    </Table.Cell>
                  </Table.Row>
                ) : (
                  <>
                    {
                      rows.map((row, i) => {
                        prepareRow(row);
                        return (
                          <Table.Row key={i}>
                            {row.cells.map((cell) => {
                              return (
                                <Table.Cell textAlign="center" {...cell.getCellProps()}>
                                  {cell.render('Cell')}
                                </Table.Cell>
                              );
                            })}
                          </Table.Row>
                        );
                      })
                    }
                  </>
                )
                }
              </>
            }
          </Table.Body>
        </Table>
      </div>
    </>
    
  );
};

export default MaintainanceTable;
